import supportpal from './i18n/index.js'

export const config = {
    placeholderNumberPolicy: 'OFF',
    numberDisplayFormat: 'E164',
    initialCountry: $('meta[name=default_country]').prop('content'),
    countryOrder: [$('meta[name=default_country]').prop('content')],
    separateDialCode: true,
    // Not included in SupportPal locale
    excludeCountries: ['cc', 'cx', 'gf', 'gi', 'gp', 'mq', 're', 'sj', 'tk', 'yt'],
    uiTranslations: supportpal,
    loadUtils: () => import('intl-tel-input/utils'),
};
